import React from "react";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import "./PravnoLiceCard.scss";
import noUser from "../imgs/user.png";
import { useNavigate } from "react-router-dom";
import config from "../config.json";

function PravnoLiceCard({
  naziv,
  kontakt,
  sjediste,
  djelatnost,
  slika,
  korisnickoIme,
}) {
  const { baseUrl } = config;
  const navigate = useNavigate();

  let testImg;
  if (slika === "None") {
    testImg = false;
  } else {
    testImg = slika;
  }

  function navigateContact() {
    navigate(`/kontaktiranje-pravnog-lica/${korisnickoIme}`);
  }

  return (
    <>
      <Card as={Container} className="card-container">
        <Card.Body as={Row}>
          <Col md={6}>
            <Card.Title> {naziv}</Card.Title>
            <Card.Text>
              Kontakt: {kontakt} <br />
              Sjedište: {sjediste} <br />
            </Card.Text>
          </Col>
          <Col md={6}>
            <Card.Img
              src={testImg ? `${baseUrl}/${slika}` : noUser}
              alt="Logotip"
              className="card-logo"
            />
          </Col>
          <Col md={12}>
            <Card.Text>
              Djelatnost pravnog lica: {djelatnost} <br />
            </Card.Text>
          </Col>
          <Col md={12}>
            <Button
              as="a"
              href=""
              id="primary"
              variant="success"
              className="card-btn"
              onClick={() => navigateContact()}
            >
              ZATRAŽI PONUDU
            </Button>
          </Col>
        </Card.Body>
      </Card>
    </>
  );
}

export default PravnoLiceCard;
